<template>
  <button
    :class="$style.closeButton"
    @click="handleClose"
  >
    <svg viewBox="0 0 45 45" xmlns="http://www.w3.org/2000/svg" :class="$style.closeButtonImg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g transform="translate(0 .5)" fill="none" fill-rule="evenodd"><ellipse cx="22.5" cy="22" rx="22.5" ry="22"/><path d="M31 14.5l-16 15m0-15l16 15" stroke="currentColor" stroke-width="2"/></g></svg>
  </button>
</template>

<script>
export default {
  name: 'CloseButton',

  props: {
    handleClose: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style module>
@value (gradientLight3) from '~css/colors.css';

button.closeButton {
  background-color: transparent;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  outline: none;
  padding: 0;
  position: absolute;
  right: 16px;
  top: 16px;
}

.closeButton svg {
  font-size: 32px;
  height: 1em;
  width: 1em;
}

.closeButtonImg { border-radius: 50%; }
.closeButtonImg:focus { outline: none; }
.closeButtonImg:hover { background-color: gradientLight3; }
</style>
